import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: 'action-snackbar',
    template: require('./action-snackbar.component.html'),
    styles: [require('./action-snackbar.component.css')]
})
export class ActionSnackbarComponent {

    @Input() buttons: ActionSnackbarButton[];

    @Input() dividerIndexes: number[];

    @Output() buttonClick = new EventEmitter<string>();

}

export class ActionSnackbarButton {
    type: ActionSnackbarButtonType;
    label: string;
    event?: string;
    icon?: string;
    menuButtons?: MenuButton[];
}

export class MenuButton {
    label: string;
    event: string;
    icon?: string;
}

export enum ActionSnackbarButtonType {
    SIMPLE = 'SIMPLE',
    SELECTED_ELEMENTS = 'SELECTED_ELEMENTS',
    MENU = 'MENU'
}